import * as yup from 'yup'

export const initialValues = {
  ruleGroup: '',
  maxPoints: '',
  maxCount: '',
}

export const validationSchema = yup.object({
  ruleGroup: yup
    .string()
    .strict(true)
    .max(50, 'Group description must be limited to 50 characters.')
    .required('Group description is required and cannot be empty.')
    .test('trim', 'Group description is required and cannot be empty.', value => {
      return value ? value.trim().length > 0 : false
    }),

  maxPoints: yup
    .string()
    .transform(value => (value === '' ? undefined : value))
    .test('is-valid-number', 'This field must be a valid number.', value => {
      if (value === undefined) return true
      const numberValue = parseFloat(value)
      return !isNaN(numberValue) && numberValue > 0
    })
    .matches(/^(?:\d+|\d*\.\d+)$/, 'This field must be a valid number'),

  maxCount: yup
    .string()
    .transform(value => (value === '' ? undefined : value))
    .test('is-valid-number', 'This field must be a valid number.', value => {
      if (value === undefined) return true
      const numberValue = parseFloat(value)
      return !isNaN(numberValue) && numberValue > 0
    })
    .matches(/^(?:\d+|\d*\.\d+)$/, 'This field must be a valid number'),
})
